import React, { useEffect, useState, useRef } from 'react'
import { Card, Modal } from 'react-bootstrap'
import { BiText } from 'react-icons/bi';
import { BsArrowLeftRight, BsCircle } from 'react-icons/bs';
import { FaRegSquareFull } from 'react-icons/fa6';
import { GiLaserburn } from 'react-icons/gi';
import InputField from '../../jsx/components/fields/inputField';
import { TiDelete } from "react-icons/ti";
import html2canvas from 'html2canvas';
import PrimaryButton from '../../jsx/components/button/primaryButton';
export default function DrawingDemo({
  useForDIY = false,
  handleScreenShot,
  setToggleForDrawing,
  drawingImageSaveLoading,
  setDrawingImageSaveLoading,
}) {
  const videoRef = useRef(null);
  const streamRef = useRef(null);
  const canvasRef = useRef(null);
  const intervalIdRef = useRef(null);

  const [drawRectangle, setDrawRectangle] = useState(false)
  const [drawCircle, setDrawCircle] = useState(false)
  const [drawLine, setDrawLine] = useState(false)
  const [drawText, setDrawText] = useState(false)
  const [laserLine, setLaserLine] = useState(false)
  const [shapes, setShapes] = useState([]);
  const [laserPointToSend, setLaserPointToSend] = useState([]);
  const [isDrawShapes, setIsDrawShapes] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const [selectedShape, setSelectedShape] = useState(null);
  const [dummyShape, setDummyShape] = useState({});
  const [resizeArea, setResizeArea] = useState("");
  const [offsetX, setOffsetX] = useState(0);
  const [offsetY, setOffsetY] = useState(0);
  const [resizing, setResizing] = useState(false);
  const [resizingShape, setResizingShape] = useState(false);
  const [cursorValue, setCursorValue] = useState("default");
  const [laserLinesArr, setLaserLinesArr] = useState([]);
  const [drawingArea, setDrawingArea] = useState(false);
  const [modalTriggerForDrawingInstructions, setModalTriggerForDrawingInstructions] = useState(true);


  useEffect(() => {
    // Access the camera
    navigator.mediaDevices.getUserMedia({ video: { facingMode: 'environment' }, audio: false, })
      .then((mediaStream) => {
        streamRef.current = mediaStream;
        if (videoRef.current) {
          videoRef.current.srcObject = mediaStream;
        }
      })
      .catch((error) => {
        console.error('Error accessing the camera:', error);
      });

    return () => {
      // debugger
      if (streamRef.current) {
        const tracks = streamRef.current.getTracks();
        tracks.forEach(track => {
          track.stop();
        });
      }
    };
  }, []);

  useEffect(() => {
    const video = document.getElementById('videoFrame');
    const canvas = canvasRef.current;

    if (video && canvas) {
      const resizeCanvas = () => {
        const computedStyle = window.getComputedStyle(video);
        canvas.width = parseInt(computedStyle.width);
        canvas.height = parseInt(computedStyle.height);
      };

      resizeCanvas();


      window.addEventListener('resize', resizeCanvas);
      handleDrawing()
      // Cleanup
      return () => {
        window.removeEventListener('resize', () => { resizeCanvas(); screenSizeChanged() });
      };
    }
  }, []);

  function screenSizeChanged() {
    setDrawCircle(false);
    setDrawLine(false);
    setDrawRectangle(false);
    setDrawText(false);
    setLaserLine(false);
    setShapes([]);
    setLaserPointToSend([]);
    setIsDrawShapes(false);
    setCursorValue("default");
    setSelectedShape(null);
    setDummyShape({});
    setResizeArea("");
    setOffsetX(0);
    setOffsetY(0);
    setResizing(false);
    setResizingShape(false);
    setLaserLinesArr([]);
    setDrawingArea(false);
  }
  const handleDrawing = () => {




    const video = document.getElementById("videoFrame");
    video.pause();


    const isRectangleExists = shapes.some((shape) => shape.type === "laser");

    if (isRectangleExists) {
    } else {
      const newRectangle = {
        id: shapes.length + 1,
        type: "laser",
        x: 0, // Adjusting to center the rectangle on the mouse click
        y: 0, // Adjusting to center the rectangle on the mouse click
        width: 0,
        height: 0,
        laserPoints: laserPointToSend,
      };

      const updatedShapes = [...shapes, newRectangle];
      setShapes(updatedShapes);
    }

    localStorage.setItem("currentShape", "rec");
    setIsDrawShapes(true);
    setDrawCircle(false);
    setDrawLine(false);
    setDrawRectangle(true);
    setDrawText(false);
    setLaserLine(false);

  };

  const handleCircle = () => {



    const video = document.getElementById("videoFrame");
    video.pause();


    const isRectangleExists = shapes.some((shape) => shape.type === "laser");

    if (isRectangleExists) {
    } else {
      const newRectangle = {
        id: shapes.length + 1,
        type: "laser",
        x: 0, // Adjusting to center the rectangle on the mouse click
        y: 0, // Adjusting to center the rectangle on the mouse click
        width: 0,
        height: 0,
        laserPoints: laserPointToSend,
      };

      const updatedShapes = [...shapes, newRectangle];
      setShapes(updatedShapes);
    }
    setIsDrawShapes(true);
    localStorage.setItem("currentShape", "cir");
    setDrawRectangle(false);
    setDrawLine(false);
    setDrawCircle(true);
    setDrawText(false);
    setLaserLine(false);

  };

  const handleLine = () => {



    const video = document.getElementById("videoFrame");
    video.pause();


    const isRectangleExists = shapes.some((shape) => shape.type === "laser");

    if (isRectangleExists) {
    } else {
      const newRectangle = {
        id: shapes.length + 1,
        type: "laser",
        x: 0, // Adjusting to center the rectangle on the mouse click
        y: 0, // Adjusting to center the rectangle on the mouse click
        width: 0,
        height: 0,
        laserPoints: laserPointToSend,
      };

      const updatedShapes = [...shapes, newRectangle];
      setShapes(updatedShapes);
    }
    setIsDrawShapes(true);
    localStorage.setItem("currentShape", "arrow");
    setDrawRectangle(false);
    setDrawCircle(false);
    setDrawLine(true);
    setDrawText(false);
    setLaserLine(false);

  };

  const handleLaserLine = () => {

    const video = document.getElementById("videoFrame");
    video.pause();

    const isRectangleExists = shapes.some((shape) => shape.type === "laser");

    if (isRectangleExists) {
    } else {
      const newRectangle = {
        id: shapes.length + 1,
        type: "laser",
        x: 0, // Adjusting to center the rectangle on the mouse click
        y: 0, // Adjusting to center the rectangle on the mouse click
        width: 0,
        height: 0,
        laserPoints: laserPointToSend,
      };

      const updatedShapes = [...shapes, newRectangle];
      setShapes(updatedShapes);
    }

    setIsDrawShapes(true);
    localStorage.setItem("currentShape", "laser");
    setDrawRectangle(false);
    setDrawCircle(false);
    setDrawLine(false);
    setDrawText(false);
    setLaserLine(true);

  };
  function handleText() {


    const video = document.getElementById("videoFrame");
    video.pause();


    const isRectangleExists = shapes.some((shape) => shape.type === "laser");

    if (isRectangleExists) {
    } else {
      const newRectangle = {
        id: shapes.length + 1,
        type: "laser",
        x: 0, // Adjusting to center the rectangle on the mouse click
        y: 0, // Adjusting to center the rectangle on the mouse click
        width: 0,
        height: 0,
        laserPoints: laserPointToSend,
      };

      const updatedShapes = [...shapes, newRectangle];
      setShapes(updatedShapes);
    }
    setIsDrawShapes(true);

    setDrawRectangle(false);
    setDrawCircle(false);
    setDrawLine(false);
    setDrawText(true);
    setLaserLine(false);
  }

  function commonFillTextFn(x, y, w, h, text) {
    var canvas = document.getElementById("canvasImage");

    var ctx = canvas.getContext("2d");
    // ctx.strokeRect(x, y, w, h);

    var pointX = x;
    var pointY = y + 18;

    ctx.font = "20px poppins";
    var gradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
    gradient.addColorStop("0", "red");
    gradient.addColorStop("0.5", "red");
    gradient.addColorStop("1.0", "red");
    // Fill with gradient
    ctx.fillStyle = gradient;

    const words = text.split("") || localStorage.getItem("keyText");

    drawWords(
      ctx,
      text,
      pointX,
      pointY,
      canvas.width - x,
      canvas.height - y,
      18,
      canvas.height - y,
      words
    );
  }

  function drawWords(
    context,
    text,
    x,
    y,
    maxWidth,
    maxHeight,
    lineHeight,
    rectHeight,
    words
  ) {
    var line = "";
    for (var n = 0; n < words.length; n++) {
      var testLine = line + words[n] + " ";
      var metrics = context.measureText(testLine);
      var testWidth = metrics.width;
      if (testWidth > maxWidth && n > 0) {
        context.fillText(line, x, y);
        line = words[n] + " ";
        y += lineHeight;
      } else {
        line = testLine;
      }
    }
    context.fillText(line, x, y);
    rectHeight = rectHeight + lineHeight;
  }

  const addPoint = (x, y, dragging) => {
    if (!dragging) return; // Ensure point is only added when dragging (mouse down)
    const newLine = { x, y };

    setLaserLinesArr((prevLines) => {
      // Ensure we don't exceed 90 points in the lines array
      const newLines = [...prevLines, newLine];
      while (newLines.length > 30) {
        newLines.shift(); // Remove the oldest points if array exceeds 90 points
      }
      return newLines;
    });
  };
  const addPointToSend = (x, y, dragging) => {
    if (!dragging) return; // Ensure point is only added when dragging (mouse down)

    var canvas = document.getElementById("canvasImage");
    const newLine = {
      recStartX: x / canvas.width,
      recStartY: y / canvas.height,
    };

    setLaserPointToSend((prevLines) => {
      // Ensure we don't exceed 90 points in the lines array
      const newLines = [...prevLines, newLine];
      while (newLines.length > 30) {
        newLines.shift(); // Remove the oldest points if array exceeds 90 points
      }
      return newLines;
    });

  };
  useEffect(() => {



    var canvas = document.getElementById("canvasImage");
    const ctx = canvas.getContext("2d");


    ctx.strokeStyle = "red";
    ctx.lineWidth = 2;

    function drawDummyShape() {
      ctx.setLineDash([1, 3]);
      ctx.strokeStyle = "red";
      ctx.strokeRect(
        dummyShape.x,
        dummyShape.y,
        dummyShape.width,
        dummyShape.height
      );
      ctx.strokeStyle = "red";

      ctx.fillStyle = "white";

      ctx.fillRect(
        dummyShape.x + dummyShape.width - 12 / 2,
        dummyShape.y + dummyShape.height - 12 / 2,
        12,
        12
      );
      ctx.fillStyle = "blue";

      ctx.fillRect(
        dummyShape.x - 3,
        dummyShape.y - 3 + dummyShape.height / 2,
        6,
        6
      );

      ctx.fillRect(
        dummyShape.x - 3 + dummyShape.width / 2,
        dummyShape.y - 3,
        6,
        6
      );
      ctx.fillRect(
        dummyShape.x - 3 + dummyShape.width,
        dummyShape.y - 3 + dummyShape.height / 2,
        6,
        6
      );
      ctx.fillRect(
        dummyShape.x - 3 + dummyShape.width / 2,
        dummyShape.y - 3 + dummyShape.height,
        6,
        6
      );
      ctx.setLineDash([]);
      // ctx.beginPath();

      // ctx.arc(dummyShape.x , dummyShape.y , 6, 0, 2 * Math.PI);
      // ctx.fill();
    }

    const drawShapes = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      redraw();

      drawDummyShape(dummyShape);

      for (const shape of shapes) {
        if (shape.type === "rectangle") {
          ctx.strokeStyle = "red";
          ctx.setLineDash([]);
          ctx.strokeRect(shape.x, shape.y, shape.width, shape.height);
        } else if (shape.type === "circle") {
          circleShowFn(shape.x, shape.y, shape.width, shape.height);
        } else if (shape.type === "text") {
          commonFillTextFn(
            shape.x,
            shape.y,
            shape.width,
            shape.height,
            shape.text
          );
        } else if (shape.type === "arrow") {
          arrowShowFn(shape.x, shape.y, shape.width, shape.height);
        }
      }
    };

    const handleMouseDown = (event) => {
      setIsDrawShapes(false);
      const rect = canvas.getBoundingClientRect();
      const mouseX = event.clientX - rect.left;
      const mouseY = event.clientY - rect.top;


      if (laserLine) {
        setIsDragging(true);
        addPointToSend(mouseX, mouseY, isDragging);
        addPoint(mouseX, mouseY, isDragging);
      }
      else {
        if (isDrawShapes) {
          if (drawRectangle) {
            const newRectangle = {
              id: shapes.length + 1,
              type: "rectangle",
              x: mouseX - 50, // Adjusting to center the rectangle on the mouse click
              y: mouseY - 50, // Adjusting to center the rectangle on the mouse click
              width: 100,
              height: 100,
            };

            setDummyShape(newRectangle);
            const updatedShapes = [...shapes, newRectangle];
            setShapes(updatedShapes);
          }

          if (drawCircle) {
            const newCircle = {
              id: shapes.length + 1,
              type: "circle",
              x: mouseX - 50, // Adjusting to center the rectangle on the mouse click
              y: mouseY - 50, // Adjusting to center the rectangle on the mouse click
              width: 100,
              height: 100,
              radius: 50, // Default radius
            };
            setDummyShape(newCircle);
            // Update the shapes array by adding the new circle
            const updatedShapes = [...shapes, newCircle];
            setShapes(updatedShapes);
          }

          if (drawText) {
            const newText = {
              id: shapes.length + 1,
              type: "text",
              x: mouseX - 35, // Adjusting to center the rectangle on the mouse click
              y: mouseY - 15, // Adjusting to center the rectangle on the mouse click
              width: 70,
              height: 30,
              text: localStorage.getItem("keyText"),
            };
            setDummyShape(newText);
            const updatedShapes = [...shapes, newText];
            setShapes(updatedShapes);
          }
          if (drawLine) {
            const newLine = {
              id: shapes.length + 1,
              type: "arrow",
              x: mouseX - 50, // Adjusting to center the rectangle on the mouse click
              y: mouseY - 50, // Adjusting to center the rectangle on the mouse click
              width: 100,
              height: 100,
            };
            setDummyShape(newLine);
            const updatedShapes = [...shapes, newLine];
            setShapes(updatedShapes);
          }
        }

        for (const shape of shapes) {
          setDummyShape(shape);

          if (
            (mouseX >= shape.x + shape.width - 6) &
            (mouseX <= shape.x + shape.width + 6) &&
            mouseY >= shape.y + shape.height - 6 &&
            mouseY <= shape.y + shape.height + 6
          ) {
            setResizeArea("right-corner");
            setDummyShape(shape);
            setResizingShape(true);
            setCursorValue("nwse-resize");
            setIsDragging(true);
            setResizing(true);
            setSelectedShape(shape);
            setOffsetX(mouseX - shape.x);
            setOffsetY(mouseY - shape.y);
            break;
          }
          if (
            (mouseX >= shape.x - 3 + shape.width) &
            (mouseX <= shape.x + shape.width + 3) &&
            mouseY >= shape.y - 3 + shape.height / 2 &&
            mouseY <= shape.y + 3 + shape.height / 2
          ) {
            setResizeArea("right");
            setCursorValue("ew-resize");
            setDummyShape(shape);
            setResizingShape(true);
            setIsDragging(true);
            setResizing(true);
            setSelectedShape(shape);
            setOffsetX(mouseX - shape.x);
            setOffsetY(mouseY - shape.y);

            break;
          } else if (
            (mouseX >= shape.x - 3) & (mouseX <= shape.x + 3) &&
            mouseY >= shape.y - 3 + shape.height / 2 &&
            mouseY <= shape.y + 3 + shape.height / 2
          ) {
            setResizeArea("left");
            setCursorValue("ew-resize");
            setDummyShape(shape);
            setResizingShape(true);
            setIsDragging(true);
            setResizing(true);
            setSelectedShape(shape);
            setOffsetX(mouseX - shape.x);
            setOffsetY(mouseY - shape.y);
          } else if (
            (mouseX >= shape.x - 3 + shape.width / 2) &
            (mouseX <= shape.x + 3 + shape.width / 2) &&
            mouseY >= shape.y - 3 &&
            mouseY <= shape.y + 3
          ) {
            setResizeArea("top");
            setCursorValue("ns-resize");
            setDummyShape(shape);
            setResizingShape(true);
            setIsDragging(true);
            setResizing(true);
            setSelectedShape(shape);
            setOffsetX(mouseX - shape.x);
            setOffsetY(mouseY - shape.y);
          } else if (
            (mouseX >= shape.x - 3 + shape.width / 2) &
            (mouseX <= shape.x + 3 + shape.width / 2) &&
            mouseY >= shape.y - 3 + shape.height &&
            mouseY <= shape.y + 3 + shape.height
          ) {
            setResizeArea("bottom");
            setCursorValue("ns-resize");
            setDummyShape(shape);
            setResizingShape(true);
            setIsDragging(true);
            setResizing(true);
            setSelectedShape(shape);
            setOffsetX(mouseX - shape.x);
            setOffsetY(mouseY - shape.y);
          }
        }

        if (resizingShape) {
          const rect = canvas.getBoundingClientRect();
          const mouseX = event.clientX - rect.left;
          const mouseY = event.clientY - rect.top;

          for (const shape of shapes) {
            if (
              mouseX >= shape.x &&
              mouseX <= shape.x + shape.width &&
              mouseY >= shape.y &&
              mouseY <= shape.y + shape.height
            ) {
              setDummyShape(shape);
              setIsDragging(true);
              setSelectedShape(shape);
              setOffsetX(mouseX - shape.x);
              setOffsetY(mouseY - shape.y);
              break;
            }
            if (
              (mouseX >= shape.x - 3 + shape.width) &
              (mouseX <= shape.x + shape.width + 3) &&
              mouseY >= shape.y - 3 + shape.height / 2 &&
              mouseY <= shape.y + 3 + shape.height / 2
            ) {
              setResizeArea("right");
              setCursorValue("ew-resize");
            } else if (
              (mouseX >= shape.x - 3) & (mouseX <= shape.x + 3) &&
              mouseY >= shape.y - 3 + shape.height / 2 &&
              mouseY <= shape.y + 3 + shape.height / 2
            ) {
              setResizeArea("left");
              setCursorValue("ew-resize");
            } else if (
              (mouseX >= shape.x - 3 + shape.width / 2) &
              (mouseX <= shape.x + 3 + shape.width / 2) &&
              mouseY >= shape.y - 3 &&
              mouseY <= shape.y + 3
            ) {
              setResizeArea("top");
              setCursorValue("ns-resize");
            } else if (
              (mouseX >= shape.x - 3 + shape.width / 2) &
              (mouseX <= shape.x + 3 + shape.width / 2) &&
              mouseY >= shape.y - 3 + shape.height &&
              mouseY <= shape.y + 3 + shape.height
            ) {
              setResizeArea("bottom");
              setCursorValue("ns-resize");
            }
          }
        } else {
          const rect = canvas.getBoundingClientRect();
          const mouseX = event.clientX - rect.left;
          const mouseY = event.clientY - rect.top;

          for (const shape of shapes) {
            if (
              mouseX >= shape.x &&
              mouseX <= shape.x + shape.width &&
              mouseY >= shape.y &&
              mouseY <= shape.y + shape.height
            ) {
              setDummyShape(shape);
              setIsDragging(true);
              setResizing(true);
              setSelectedShape(shape);
              setOffsetX(mouseX - shape.x);
              setOffsetY(mouseY - shape.y);
              break;
            }
          }
        }
      }
    };

    const handleMouseMove = (event) => {
      const rect = canvas.getBoundingClientRect();
      const mouseX = event.clientX - rect.left;
      const mouseY = event.clientY - rect.top;
      setCursorValue("default");
      if (laserLine) {
        // drawShapes()
        addPointToSend(mouseX, mouseY, isDragging);
        addPoint(mouseX, mouseY, isDragging);
      } else {
        for (const shape of shapes) {
          const rect = canvas.getBoundingClientRect();
          const mouseX = event.clientX - rect.left;
          const mouseY = event.clientY - rect.top;

          if (
            (mouseX >= shape.x + shape.width - 6) &
            (mouseX <= shape.x + shape.width + 6) &&
            mouseY >= shape.y + shape.height - 6 &&
            mouseY <= shape.y + shape.height + 6
          ) {
            setDummyShape(shape);
            setCursorValue("nwse-resize");
          } else {
            if (
              (mouseX >= shape.x) & (mouseX <= shape.x + shape.width) &&
              mouseY >= shape.y &&
              mouseY <= shape.y + shape.height
            ) {
              setDummyShape(shape);
              setCursorValue("all-scroll");
            }
          }

          if (
            (mouseX >= shape.x - 3 + shape.width) &
            (mouseX <= shape.x + shape.width + 3) &&
            mouseY >= shape.y - 3 + shape.height / 2 &&
            mouseY <= shape.y + 3 + shape.height / 2
          ) {
            setResizing(true);
            setSelectedShape(shape);
            setResizeArea("right");
            setCursorValue("ew-resize");
          } else if (
            (mouseX >= shape.x - 3) & (mouseX <= shape.x + 3) &&
            mouseY >= shape.y - 3 + shape.height / 2 &&
            mouseY <= shape.y + 3 + shape.height / 2
          ) {
            setResizing(true);
            setSelectedShape(shape);
            setResizeArea("left");
            setCursorValue("ew-resize");
          } else if (
            (mouseX >= shape.x - 3 + shape.width / 2) &
            (mouseX <= shape.x + 3 + shape.width / 2) &&
            mouseY >= shape.y - 3 &&
            mouseY <= shape.y + 3
          ) {
            setResizing(true);
            setSelectedShape(shape);
            setResizeArea("top");
            setCursorValue("ns-resize");
          } else if (
            (mouseX >= shape.x - 3 + shape.width / 2) &
            (mouseX <= shape.x + 3 + shape.width / 2) &&
            mouseY >= shape.y - 3 + shape.height &&
            mouseY <= shape.y + 3 + shape.height
          ) {
            setResizing(true);
            setSelectedShape(shape);
            setResizeArea("bottom");
            setCursorValue("ns-resize");
          }
        }

        if (resizingShape) {
          if (isDragging && selectedShape && resizing) {
            const rect = canvas.getBoundingClientRect();
            const mouseX = event.clientX - rect.left;
            const mouseY = event.clientY - rect.top;

            const dx = mouseX - selectedShape.x - offsetX;
            const dy = mouseY - selectedShape.y - offsetY;

            if (resizeArea == "right-corner") {
              if (
                selectedShape.width + dx >= 20 &&
                selectedShape.height + dy >= 20
              ) {
                const updatedShape = {
                  ...selectedShape,
                  width: selectedShape.width + dx,
                  height: selectedShape.height + dy,
                };
                setDummyShape(updatedShape);
                const updatedShapes = shapes.map((shape) =>
                  shape.id === selectedShape.id ? updatedShape : shape
                );
                setShapes(updatedShapes);
              }
            } else if (resizeArea == "left") {
              if (selectedShape.width + (selectedShape.x - mouseX) >= 20) {
                const updatedShape = {
                  ...selectedShape,
                  x: mouseX,
                  width: selectedShape.width + (selectedShape.x - mouseX),
                };
                setDummyShape(updatedShape);
                const updatedShapes = shapes.map((shape) =>
                  shape.id === selectedShape.id ? updatedShape : shape
                );
                setShapes(updatedShapes);
              }
            } else if (resizeArea == "right") {
              if (mouseX - selectedShape.x >= 20) {
                const updatedShape = {
                  ...selectedShape,

                  width: mouseX - selectedShape.x,
                };
                setDummyShape(updatedShape);
                const updatedShapes = shapes.map((shape) =>
                  shape.id === selectedShape.id ? updatedShape : shape
                );
                setShapes(updatedShapes);
              }
            } else if (resizeArea == "top") {
              if (selectedShape.height + (selectedShape.y - mouseY) >= 20) {
                const updatedShape = {
                  ...selectedShape,
                  y: mouseY,
                  height: selectedShape.height + (selectedShape.y - mouseY),
                };
                setDummyShape(updatedShape);
                const updatedShapes = shapes.map((shape) =>
                  shape.id === selectedShape.id ? updatedShape : shape
                );
                setShapes(updatedShapes);
              }
              // y: mouseY, height: prev.height + (prev.y - mouseY)
            } else if (resizeArea == "bottom") {
              if (mouseY - selectedShape.y >= 20) {
                const updatedShape = {
                  ...selectedShape,

                  height: mouseY - selectedShape.y,
                };
                setDummyShape(updatedShape);
                const updatedShapes = shapes.map((shape) =>
                  shape.id === selectedShape.id ? updatedShape : shape
                );
                setShapes(updatedShapes);
              }
            }
          }
        } else {
          if (isDragging && selectedShape) {
            const rect = canvas.getBoundingClientRect();
            const mouseX = event.clientX - rect.left;
            const mouseY = event.clientY - rect.top;
            const updatedShape = {
              ...selectedShape,
              x: mouseX - offsetX,
              y: mouseY - offsetY,
            };
            setDummyShape(updatedShape);
            const updatedShapes = shapes.map((shape) =>
              shape.id === selectedShape.id ? updatedShape : shape
            );
            setShapes(updatedShapes);
          }
        }
      }
    };

    const handleMouseUp = () => {
      setIsDragging(false);
      setResizingShape(false);
      setCursorValue("default");
      setSelectedShape(null);
      setResizeArea("");
      setDummyShape({
        x: 0,
        y: 0,
        width: 0,
        height: 0,
      });
    };

    // Touch event handlers
    const handleTouchStart = (event) => {
      const rect = canvas.getBoundingClientRect();
      const touchX = event.touches[0].clientX - rect.left;
      const touchY = event.touches[0].clientY - rect.top;
      handleMouseDown({ clientX: touchX, clientY: touchY });
    };

    const handleTouchMove = (event) => {
      const rect = canvas.getBoundingClientRect();
      const touchX = event.touches[0].clientX - rect.left;
      const touchY = event.touches[0].clientY - rect.top;
      handleMouseMove({ clientX: touchX, clientY: touchY });
    };

    const handleTouchEnd = () => {
      handleMouseUp();
    };

    canvas.addEventListener("mousedown", handleMouseDown);
    canvas.addEventListener("mousemove", handleMouseMove);
    canvas.addEventListener("mouseup", handleMouseUp);
    canvas.addEventListener("touchstart", handleTouchStart);
    canvas.addEventListener("touchmove", handleTouchMove);
    canvas.addEventListener("touchend", handleTouchEnd);

    drawShapes();

    const fadePoints = () => {
      if (laserLinesArr.length > 1) {
        setLaserLinesArr((prevLines) => prevLines.slice(1));
        setLaserPointToSend((prevLines) => prevLines.slice(1));
      } else if (laserLinesArr.length === 1) {
        setLaserLinesArr([]);
        setLaserPointToSend([]);
      } else {
        // If no lines left, clear the interval
        clearInterval(intervalIdRef.current);
      }
    };

    // Only set the interval if it's not already running
    if (laserLinesArr.length > 0 && intervalIdRef.current === null) {
      intervalIdRef.current = setInterval(fadePoints, 40);
    }

    return () => {
      canvas.removeEventListener("mousedown", handleMouseDown);
      canvas.removeEventListener("mousemove", handleMouseMove);
      canvas.removeEventListener("mouseup", handleMouseUp);
      canvas.removeEventListener("touchstart", handleTouchStart);
      canvas.removeEventListener("touchmove", handleTouchMove);
      canvas.removeEventListener("touchend", handleTouchEnd);
      if (intervalIdRef.current !== null) {
        clearInterval(intervalIdRef.current);
        intervalIdRef.current = null; // Reset the ref after clearing the interval
      }
    };

  }, [
    shapes,
    isDragging,
    selectedShape,
    offsetX,
    offsetY,
    drawRectangle,
    drawCircle,
    drawText,
    localStorage.getItem("keyText"),
    isDrawShapes,
    dummyShape,
    laserLinesArr,
    resizeArea,
  ]);



  const redraw = () => {

    const canvas = document.getElementById("canvasImage");
    const context = canvas.getContext("2d");
    context.clearRect(0, 0, canvas.width, canvas.height); // Clears the canvas

    context.strokeStyle = "red";
    context.lineJoin = "round";
    context.lineWidth = 2;

    // Draw the line segments
    for (let i = 0; i < laserLinesArr.length; i++) {
      const line = laserLinesArr[i];
      context.beginPath();
      if (i > 0) {
        context.moveTo(laserLinesArr[i - 1].x, laserLinesArr[i - 1].y);
      } else {
        // This ensures the line starts properly even if not moving
        context.moveTo(line.x - 1, line.y);
      }
      context.lineTo(line.x, line.y);
      context.stroke(); // No need to closePath() when only stroking a line
    }

    if (laserLinesArr.length > 0) {
      // Move both the glitter effect and circle drawing to the end of the line
      const endLine = laserLinesArr[laserLinesArr.length - 1];
      addGlitterEffect(context, endLine.x, endLine.y);

      // Draw a red circle at the end of the line for visual emphasis
      context.beginPath();
      context.arc(endLine.x, endLine.y, 5, 0, 2 * Math.PI, false); // Circle at the end
      context.fillStyle = "red";
      context.fill();
    }

  };

  // The addGlitterEffect function definition remains the same

  // Function to add glitter effect at a given position
  function addGlitterEffect(context, x, y) {
    const glitterCount = 20; // Number of glitter particles
    for (let i = 0; i < glitterCount; i++) {
      const angle = Math.random() * Math.PI * 2; // Random angle for glitter direction
      const distance = Math.random() * 10; // Random distance from the point
      const glitterX = x + Math.cos(angle) * distance;
      const glitterY = y + Math.sin(angle) * distance;

      const glitterSize = Math.random() * 3; // Random size for each glitter particle

      // Draw glitter
      context.beginPath();
      context.arc(glitterX, glitterY, glitterSize, 0, Math.PI * 2, false);
      context.fillStyle = "yellow"; // Glitter color
      context.fill();
    }
  }

  function arrowShowFn(x, y, w, h) {
    var canvas = document.getElementById("canvasImage");
    var ctx = canvas.getContext("2d");
    // ctx.clearRect(0, 0, canvas.width, canvas.height)

    var startX = x;
    var startY = y;
    var height = h;
    var width = w;

    ctx.beginPath();
    var newStartY = parseInt(height / 2) + startY;
    var center = width / 2;

    ctx.moveTo(startX + center, newStartY);
    ctx.lineTo(startX - 100, newStartY);
    ctx.stroke();

    ctx.beginPath();
    var newStartY = parseInt(height / 2) + startY;

    ctx.moveTo(startX + center, newStartY);
    ctx.lineTo(startX - 20 + center, newStartY - 10);
    ctx.stroke();

    ctx.beginPath();
    var newStartY = parseInt(height / 2) + startY;

    ctx.moveTo(startX + center, newStartY);
    ctx.lineTo(startX - 20 + center, newStartY + 10);
    ctx.stroke();
  }

  function circleShowFn(x, y, w, h) {
    var startX = x;
    var startY = y;
    var mouseX = x + w;
    var mouseY = y + h;

    var canvas = document.getElementById("canvasImage");

    var ctx = canvas.getContext("2d");
    // ctx.clearRect(0, 0, canvas.width, canvas.height)

    ctx.save();
    ctx.beginPath();
    //Dynamic scaling
    var scalex = 1 * ((mouseX - startX) / 2);
    var scaley = 1 * ((mouseY - startY) / 2);
    ctx.scale(scalex, scaley);
    //Create ellipse
    var centerx = startX / scalex + 1;
    var centery = startY / scaley + 1;
    ctx.arc(centerx, centery, 1, 0, 2 * Math.PI);
    //Restore and draw
    ctx.restore();

    ctx.stroke();
  }

  function resetArea() {
    const video = document.getElementById("videoFrame");
    video.play();

    setShapes([])
    setDummyShape({})
    setDrawCircle(false)
    setDrawLine(false)
    setDrawRectangle(false)
    setDrawText(false)
    setLaserLine(false)
  }

  const capture = async () => {

    if (videoRef.current) {
      try {
        setDrawingImageSaveLoading(true)
        html2canvas(document.getElementById("canvasImagePass"))
          .then((canvas) => {
            canvas.style.display = "none";
            document.body.appendChild(canvas);
            return canvas;
          })
          .then((canvas) => {
            const showImage = canvas.toDataURL("image/png");
            // setShowImg(showImage);

            const image = canvas
              .toDataURL("image/png")
              .replace("data:", "")
              .replace(/^.+,/, "");


            const byteCharacters = atob(image);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray]);
            const newblob = blob.slice(0, blob.size, "image/png");
            //  console.log(newblob,"bne")
            handleScreenShot(newblob, showImage);
          });
      } catch (error) {
        console.error('Error capturing screenshot:', error);
      } finally {
        setDrawingImageSaveLoading(false)
      }
    }
  };
  return (
    <>
      <div
        className="row d-flex justify-content-center align-items-center"
        style={{ height: "" }}
      >
        <Card className="bg-white" style={{ width: "98%" }}>
          <Card.Header className="d-block">
            <Card.Title style={{ fontWeight: '700' }}>Drawning Controls</Card.Title>

          </Card.Header>

          <Card.Body className="card-body-video p-1" id={`canvasImagePass`}>

            <div className="row " style={{ position: 'absolute', top: "47px", right: 0, zIndex: '2' }}>
              <div className="col">
                {/* <div className="row ">
                                  <span
                                    className="fs-6  "
                                    style={{ fontWeight: "600" }}>
                                    Shapes
                                  </span>
                                </div> */}

                <div className="row mt-4">
                  <span
                    className="d-flex justify-content-center align-items-center"
                    style={{
                      height: "48px",
                      width: "48px",
                      marginRight: "10px",
                      marginBottom: "10px",
                      border: " 1px solid rgba(86, 86, 86, 1)",
                    }} onClick={handleDrawing}>
                    <FaRegSquareFull
                      className="pointer"
                      style={{
                        color: drawRectangle
                          ? "green"
                          : "orange",
                        width: "18px",
                        height: "18px",
                      }}

                    />
                  </span>

                  <span
                    className="d-flex justify-content-center align-items-center"
                    style={{
                      height: "48px",
                      width: "48px",
                      marginRight: "10px",
                      marginBottom: "10px",
                      border: " 1px solid rgba(86, 86, 86, 1)",
                    }} onClick={handleCircle}>
                    <BsCircle
                      className="pointer"
                      style={{
                        color: drawCircle ? "green" : "orange",
                        width: "18px",
                        height: "18px",
                      }}

                    />
                  </span>
                  <span
                    className="d-flex justify-content-center align-items-center"
                    style={{
                      height: "48px",
                      width: "48px",
                      marginRight: "10px",
                      marginBottom: "10px",
                      border: " 1px solid rgba(86, 86, 86, 1)",
                    }} onClick={handleLine}>
                    <BsArrowLeftRight
                      className="pointer"
                      style={{
                        color: drawLine ? "green" : "orange",
                        width: "18px",
                        height: "18px",
                      }}

                    />
                  </span>

                  {/* <span
                                    className="d-flex justify-content-center align-items-center"
                                    style={{
                                      height: "48px",
                                      width: "48px",
                                      marginRight: "10px",
                                      marginBottom: "10px",
                                      border: " 1px solid rgba(86, 86, 86, 1)",
                                    }} onClick={handleText}>
                                    <BiText
                                      className="pointer"
                                      style={{
                                        color: drawText ? "green" : "orange",
                                        width: "18px",
                                        height: "18px",
                                      }}
                                    
                                    />
                                  </span> */}

                  <span
                    className="d-flex justify-content-center align-items-center"
                    style={{
                      height: "48px",
                      width: "48px",
                      marginRight: "10px",
                      marginBottom: "10px",
                      border: " 1px solid rgba(86, 86, 86, 1)",
                    }} onClick={handleLaserLine}>
                    <GiLaserburn
                      className="pointer"
                      style={{
                        color: laserLine ? "green" : "orange",
                        width: "18px",
                        height: "18px",
                      }}

                    />
                  </span>
                  <span
                    className="d-flex justify-content-center align-items-center"
                    style={{
                      height: "48px",
                      width: "48px",
                      marginRight: "10px",
                      marginBottom: "10px",
                      border: " 1px solid rgba(86, 86, 86, 1)",
                    }} onClick={resetArea}>
                    <TiDelete
                      className="pointer"
                      style={{
                        color: "orange",
                        width: "18px",
                        height: "18px",
                      }}

                    />
                  </span>
                </div>
                {/* 
                                {drawText && (
                                  <div className="row mt-3">
                                    <InputField
                                      labelName={"Text"}
                                      
                                      errorMeesage={"Please enter text name"}
                                      value={localStorage.getItem("keyText")}
                                    />
                                  </div>
                                )} */}


              </div>
            </div>


            <canvas
              id="canvasImage"
              style={{ position: "absolute", zIndex: '1', cursor: cursorValue }}
              ref={canvasRef}

            ></canvas>

            <video
              ref={videoRef}
              id="videoFrame"
              playsInline
              autoPlay={true}
              style={{ objectFit: "cover", border: "2px solid #ff7a35", width: '100%', height: 'calc(70dvh)' }}
              muted={true}></video>


          </Card.Body>

          {useForDIY &&
            <>
              <div className='row my-2'>
                <div className='col-12 d-flex justify-content-center align-items-center'>
                  <PrimaryButton
                    buttonName={"CAPTURE"}
                    onClick={() => {
                      capture();
                      setDrawingImageSaveLoading(true);
                    }}
                    isLoading={drawingImageSaveLoading}
                    loadingMessage={"SAVING IMAGE TO SUGGESTIONS NOTES..."}
                    className={""}
                    style={{
                      width: 'auto',
                      background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                      border: '2px solid rgba(255, 154, 32, 1)',
                      boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                      fontWeight: '600',
                    }}
                  />
                </div>
              </div>
            </>
          }


        </Card>
      </div>

      {/* Instruction modal for drawing */}
      <Modal
        className="fade"
        show={modalTriggerForDrawingInstructions}
        // onHide={handleClose}
        centered
        size='sm'
      >
        <Modal.Body>
          <div className="row mx-0">
            <div className="col-12 px-0">
              <div className="row mx-0">
                <div className="col-12 px-0 d-flex align-items-center justify-content-end fs-4 text-black">
                  <span
                    onClick={() => setModalTriggerForDrawingInstructions(false)}
                    className="cursor-pointer">
                    <i className="bi bi-x-lg"></i>
                  </span>
                </div>
              </div>

              <>
                <div className="row mx-0 mb-3">
                  <div className="fw-bold col-12 px-0 d-flex align-items-center justify-content-center fs-3 text-black">
                    <span className="">{"Drawing"}</span>
                  </div>
                </div>

                <div className="row mx-0 mt-3 pb-2">
                  <div className="col-12 px-0 d-flex justify-content-center align-items-center flex-column">
                    <span className="fs-5 text-center mb-2">
                      {"Click on a shape from top right corner (the screen will freeze) and then click anywhere on the screen to place that shape over the image."}
                    </span>

                    {useForDIY &&
                      <span className="fs-5 text-center">
                        {"Then 'Save' the image for review."}
                      </span>
                    }
                  </div>
                </div>

                <div className="row mx-0 text-black mt-3">
                  <div className="col-12 font-w600 mb-2">
                    <PrimaryButton
                      onClick={(e) => {
                        setModalTriggerForDrawingInstructions(false);
                      }}
                      buttonName={"OKAY"}
                      isLoading={false}
                      loadingMessage={'Loading...'}
                      style={{
                        width: "100%",
                        backgroundColor: "white",
                        border: "1px solid grey",
                        color: "black",
                        fontWeight: '600',
                      }}
                    />


                  </div>
                </div>
              </>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}
